import { useState } from 'react';
import * as React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css';

import './App.scss';

import Navigation from './navigation';
import { ToastContainer } from 'react-toastify';
import { ensureGuestSession } from './Services/GuestSession';
const App = () => {
  // 23/09/2026: get an anonymous guest token before the public pages call the
  // API, the same way the mobile app does on first launch. Without it those
  // pages break the moment the backend runs with REQUIRE_CUSTOMER_TOKEN=true.
  // Harmless while that switch is off, and it never replaces a real login.
  React.useEffect(() => {
    ensureGuestSession();
  }, []);

  return (
    <>
      <div className="App">
        <Navigation />
        <ToastContainer />
      </div>
    
    </>
  );
};
export default App;
